import { makeAutoObservable } from 'mobx'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { createProviderDataApi } from '../api/providersData.api'

const TOKEN_RENEW_TIME_OUT = 14 * 60 * 1000

export type ProviderDataApi = ReturnType<typeof createProviderDataApi>

export class ProvidersDataStore {
  childApi: ProviderDataApi
  root: ShopRootStore
  payPalUserIdToken = null
  renewInterval = null
  name: 'providersDataStore'

  constructor(root: ShopRootStore) {
    this.root = root

    this.childApi = createProviderDataApi(root.apiClient)

    makeAutoObservable(this)
  }

  fetchPaypalIdToken = async (shopName: string, provider: string, data: any) => {
    const resp = await this.childApi.fetchPaypalIdToken(shopName, provider, data)

    if (resp.success) {
      this.payPalUserIdToken = resp.data?.paypalIdToken
    }
    return resp
  }

  scheduleRenew = (shopName: string, provider: string, data: any, callback: (token: string) => void) => {
    this.renewInterval = setInterval(() => {
      this.fetchPaypalIdToken(shopName, provider, data).then((resp) => {
        if (resp && resp.success) {
          callback(resp.data?.paypalIdToken)
        }
      })
    }, TOKEN_RENEW_TIME_OUT)
  }

  cancelRenew = () => {
    clearInterval(this.renewInterval)
  }

  hydrate(key, data) {
    if (key === 'payPalUserIdToken') {
      this.payPalUserIdToken = data
    }
  }
}
